import React from 'react';
import { t } from '../../../RI18n';
import './DashboardHeader.css';

class DashboardHeader extends React.Component {
  getDescription = () => t('dashboard.description_lmt');

  render() {
    return (
      <div className="bx--row">
        <div className="bx--col-lg-6">
          <header className="Dashboard-header" id="row-header">
            <h2 className="Dashboard-title">{t('dashboard.title')}</h2>
            <a href="/sam" className="bx--link">
              {t('dashboard.old_dashboard_link')}
            </a>
          </header>
        </div>

        <div className="bx--col-lg-12">
          <p>{this.getDescription()}</p>
        </div>
      </div>
    );
  }
}

export default DashboardHeader;
